// extracted by mini-css-extract-plugin
export default {"Menu":"bgv_a bhk_h","Menu__offsetParent":"bgv_b bhk_bj","Menu__trigger--shadowed":"bgv_c"};